import type { ControlProps, GroupBase } from 'react-select';
import { components } from 'react-select';
import type { OptionType } from '../types';

export const CustomControl = <T extends OptionType>(props: ControlProps<T, true, GroupBase<T>>) => {
  return <components.Control {...props}>{props.children}</components.Control>;
};
